import * as React from 'react';
import * as style from './MapPreview.css';

export interface IFullAddressProps {
  mapPreview: string;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export function MapPreview({ mapPreview, onClick }: IFullAddressProps) {
  return (
    <div className={style['map']} onClick={onClick}>
      <div className={style['map-pin']}></div>
      <img className={style['map']} src={mapPreview} />
    </div>
  );
}
